import React from 'react';
import { SecureHtml } from '@wix/wix-emails-secure-components';
import { ColumnItem } from '../column-item';
export function Spacer({ containerBackgroundColor, cssClass, height = '20px', }) {
    return (React.createElement(ColumnItem, { cssClass: cssClass, containerBackgroundColor: containerBackgroundColor },
        React.createElement(SecureHtml, { containerProps: { style: { height, lineHeight: height } }, html: '&#8202;', skipCleaning: true })));
}
//# sourceMappingURL=spacer.js.map